import { render } from "./app-root.vue?vue&type=template&id=3797a22c"
import script from "./app-root.vue?vue&type=script&lang=js"
export * from "./app-root.vue?vue&type=script&lang=js"

import "./app-root.vue?vue&type=style&index=0&id=3797a22c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__